export default "__VITE_ASSET__RXdoTT7s__"